// API client para Reporte de Seguros de Asesores
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Obtiene el reporte de seguros de asesores con paginación REAL en backend.
 *
 * El filtro por ciclo escolar fue removido a propósito: este reporte ahora
 * lista todos los asesores (acotados opcionalmente por campus). Si se envía
 * `id_ciclo_escolar` el backend lo ignora (compat).
 *
 * @param {Object} params
 * @param {number|string} [params.id_campus]      - Filtro opcional por campus.
 * @param {number}        [params.page=1]         - Página (base 1).
 * @param {number}        [params.page_size=15]   - Tamaño de página.
 * @param {boolean}       [params.all=false]      - Trae todo lo filtrado sin
 *                                                   paginar (export Excel).
 *
 * Respuesta:
 *  { resultados, total, page, page_size, total_pages, filtros_aplicados }
 */
export async function getReporteSegurosAsesores(params = {}) {
  const {
    id_campus,
    page = 1,
    page_size = 15,
    all = false,
  } = params;

  const qs = new URLSearchParams();
  if (id_campus && id_campus !== 'todos') qs.set('id_campus', id_campus);
  if (all) {
    qs.set('all', 'true');
  } else {
    qs.set('page', String(page));
    qs.set('page_size', String(page_size));
  }
  qs.set('_t', String(Date.now()));

  const res = await fetch(`${API_BASE}/escolar/reportes/seguros-asesores/?${qs.toString()}`, {
    headers: getAuthHeaders(),
    cache: 'no-store',
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`GET /reportes/seguros-asesores/ ${res.status}: ${text}`);
  }
  return res.json();
}

export default getReporteSegurosAsesores;

